<div class="container">
  <div class="heading">
    <h1 class="span"><span translate>DG-DYNAMIC-GRID-COMPONENT</span></h1>
    <a href="{{ doc_url }}"
      ><mat-icon class="span" id="link">attachment</mat-icon></a
    >
  </div>
  <div class="row">
    <mat-checkbox class="col-md-3" [(ngModel)]="isEditable">
      Editable
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="canAddRow">
      Can Add Row
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isSaveAll">
      Save All
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="addRowAtTop">
      Add Row At Top
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isLoading">
      Loading
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="showSearch">
      Show Search
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isExternalSearch">
      External Search
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isExternalSorting">
      External Sorting
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isRowSelectable">
      Row Selection
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="allowMultiRowSelection">
      Row Multi Selection
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="showCheckboxForSelection">
      Row Multi Checkbox Selection
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="canEditInline">
      Inline Edit
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isExternalPaging">
      External Pagination
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isDeleteAll">
      Delete All
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="canAddMultipleRows">
      Can Add Multiple Rows
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="canDeleteMultipleRows">
      Can Delete Multiple Rows
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="beginWithAddedRow">
      Begin With Added Row
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="isRowExpandable">
      Row Expandable
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="showEmptyIllustration">
      Show Empty Illustration
    </mat-checkbox>
    <mat-checkbox class="col-md-3" [(ngModel)]="showColumnSelection">
      Show Column Selection
    </mat-checkbox>
    <mat-checkbox
      class="col-md-3"
      [(ngModel)]="configAtRow"
      (change)="refreshGrid()"
    >
      Config At Row
    </mat-checkbox>
  </div>
  <div class="row mt-3">
    <mat-form-field class="col-md-3">
      <mat-label>Column Pinning</mat-label>
      <mat-select
        disableOptionCentering
        panelClass="matSelectPanel"
        [(ngModel)]="pinColumn"
      >
        <mat-option
          *ngFor="let option of [undefined, 'left', 'right']"
          [value]="option"
        >
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="col-md-3">
      <input
        matInput
        [(ngModel)]="pageSize"
        type="number"
        placeholder="Page Size"
      />
    </mat-form-field>
    <mat-form-field class="col-md-3">
      <input
        matInput
        [(ngModel)]="totalRows"
        type="number"
        placeholder="Total Rows"
      />
    </mat-form-field>
    <div class="col-md-3">
      <button mat-raised-button color="primary" (click)="refreshGrid()">
        <mat-icon>cached</mat-icon>Refresh Grid
      </button>
    </div>
  </div>

  <!-- Grid -->
  <dynamic-grid
    #dynamicGrid
    [rows]="rows"
    [cols]="cols"
    [isEditable]="isEditable"
    [canAddRow]="canAddRow"
    [isSaveAll]="isSaveAll"
    [addRowAtTop]="addRowAtTop"
    [isLoading]="isLoading"
    [showSearch]="showSearch"
    [showColumnSelection]="showColumnSelection"
    [canEditInline]="canEditInline"
    [isRowSelectable]="isRowSelectable"
    [beginWithAddedRow]="beginWithAddedRow"
    [colPropConfig]="colPropConfig"
    [comboPropConfig]="comboPropConfig"
    [allowMultiRowSelection]="allowMultiRowSelection"
    [showCheckboxForSelection]="showCheckboxForSelection"
    [pinColumn]="pinColumn"
    [pageSize]="pageSize"
    [isDeleteAll]="isDeleteAll"
    [canAddMultipleRows]="canAddMultipleRows"
    [canDeleteMultipleRows]="canDeleteMultipleRows"
    [isExternalPaging]="isExternalPaging"
    [isExternalSorting]="isExternalSorting"
    [isExternalSearch]="isExternalSearch"
    [tableOffset]="offset"
    [totalRows]="totalRows"
    [isRowexpandable]="isRowExpandable"
    [exportOptions]="exportOptions"
    [messages]="messages"
    [legends]="legends"
    [showEmptyIllustration]="showEmptyIllustration"
    [rowDetailConfig]="rowDetailConfig"
    (onActionPerformed)="onActionPerformed($event)"
    (onInputChange)="onInputChange($event)"
    (onRowSelection)="onRowSelection($event)"
    (onLinkClick)="onLinkClick($event)"
    (onIconClick)="onIconClick($event)"
    (onPageChange)="onPageChange($event)"
    (onSearchQueryChange)="onSearchQueryChange($event)"
    (onSort)="onSort($event)"
    (onExportOptionClick)="onExportOptionClick($event)"
    (onFilterChange)="onFilterChange($event)"
  ></dynamic-grid>

  <div *ngIf="isSaveAll">
    <button mat-raised-button class="save-all-button" (click)="submit()">
      Submit
    </button>
  </div>
</div>
